export const REPRESENTATION_GROUP: string = 'Representation';
export const FILE_GROUP: string = 'File';
